





























































































































import { Component, Vue } from 'vue-property-decorator';
import ProfileEntry from '@/components/ProfileEntry.vue';
@Component({
  components: { ProfileEntry },
})
export default class Work extends Vue {}
